import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsPromotionDetailsWidget" */ './SportsPromotionDetailsWidget'),
  modules: ['./SportsPromotionDetailsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
